export default {
	data() {
		return {
			mixin_myCenterMenuList: [
				{
					code: 'wddd',
					icon: 'icon-wodedingdan',
					name: '我的订单',
					path: '/order-list'
				},
				{
					code: 'wdzh',
					icon: 'icon-wodezhanghu',
					name: '我的账户',
					path: '/myAccount'
				},
				{
					code: 'lqzx',
					icon: 'icon-lingquanzhongxin',
					name: '我的优惠券',
					path: '/myCoupon'
				},
				{
					code: 'shdz',
					icon: 'icon-shouhuodizhi',
					name: '收货地址',
					path: '/location'
				},{
					code: 'drbj',
					icon: 'icon-shouhuodizhi',
					name: '导入比价',
					path: '/comparePrice'
				},
				{
					code: 'kffw',
					icon: 'icon-kefufuwu',
					name: '客服服务',
					path: '/service'
				},
				{
					code: 'xpsj',
					icon: 'icon-xinpinshouji',
					name: '新品收集',
					path: '/newGather'
				},
				{
					code: 'jyzz',
					icon: 'icon-jingyingzizhi',
					name: '经营资质',
					path: '/certification'
				},
				{
					code: 'zhxx',
					icon: 'icon-zhanghao',
					name: '账号信息',
					path: '/accountInfo'
				},
				{
					code: 'xgmm',
					icon: 'icon-guanyuwomen',
					name: '修改密码',
					path: '/changePasswd'
				}
			]
		}
	},
	created() {
	},
	methods: {
	 /**
     * 2020-03-05 董浩
     * 格式化日期
     * date: 日期
	 * formatString: 格式化日期格式
	 * return 格式化后字符串日期
     */
	 sn_formatDate(date, formatString) {
      let formatDate = formatString

      let year = date.getFullYear()
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

      formatDate = formatDate.replace("yyyy", year);
      formatDate = formatDate.replace("MM", month);
      formatDate = formatDate.replace("dd", day);
      formatDate = formatDate.replace("HH", hours);
      formatDate = formatDate.replace("mm", minutes);
      formatDate = formatDate.replace("ss", seconds);
      return formatDate;
     }
	}
}